import { IconButton } from '@foam/buoy/src/components/IconButton/IconButton';
import {
  BrandLogo,
  DragHandle,
} from '~/screens/PageBuilder/modals/BrandExperienceModal';

import { ReorderGrid, ReorderItem } from './ReorderGrid';

interface SelectedLogo {
  id: string;
  url: string;
  brandName: string;
}

interface SelectedBrandLogosProps {
  logos: SelectedLogo[];
  onDeleteLogo?: (logoId: string) => void;
  onReorder?: (newOrder: SelectedLogo[]) => void;
}

export const SelectedBrandLogos = ({
  logos,
  onDeleteLogo,
  onReorder,
}: SelectedBrandLogosProps) => {
  const handleDelete = (logoId: string) => {
    if (onDeleteLogo) {
      onDeleteLogo(logoId);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="max-h-[400px] overflow-y-auto">
        <ReorderGrid
          values={logos}
          onReorder={onReorder ?? (() => {})}
          renderOverlay={(item) => (
            <BrandLogo
              src={item.url}
              alt={item.brandName}
              variant={item.url.includes('logo?c=') ? 'full' : 'standard'}
            />
          )}
          className="grid auto-rows-fr grid-cols-5 gap-2"
        >
          {logos.map((logo) => (
            <ReorderItem
              key={logo.id}
              value={logo}
              borderRadius="lg"
              overflow="hidden"
              position="relative"
              _hover={{
                '.item-action-buttons': {
                  visibility: 'visible',
                },
              }}
              dragControls={true}
            >
              <div className="group relative">
                <BrandLogo
                  key={logo.id}
                  src={logo.url}
                  alt={logo.brandName}
                  variant={logo.url.includes('logo?c=') ? 'full' : 'standard'}
                  onClick={() => {}}
                />
                <div className="absolute right-2 top-2 flex gap-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                  <DragHandle id={logo.id} />
                  <IconButton
                    variant="tertiary"
                    aria-label="Delete logo"
                    size="md"
                    icon="Trash"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(logo.id);
                    }}
                    track-id="brand-logo-delete-btn"
                  />
                </div>
              </div>
            </ReorderItem>
          ))}
        </ReorderGrid>
      </div>
    </div>
  );
};
